import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  readMoreBox: {
    maxHeight: 170,
    overflow: 'hidden',
    position: 'relative',
    '& p': {
      color: theme.palette.primary.main
    }
  },
  readMoreBoxRevealed: {
    maxHeight: 'none',
    overflow: 'visible'
  },
  readMoreButtonContainer: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    margin: 0,
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(5),
    backgroundImage: 'linear-gradient(to bottom, transparent, white)',
    '& button': {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 'bold',
      fontSize: '1.125em',
      width: '100%',
      border: 'none',
      background: 'none',
      color: theme.palette.primary.main,
      textAlign: 'left',
      textDecoration: 'underline'
    }
  },
  sectionContainer: {
    padding: theme.spacing(2, 3),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    background: theme.palette.background.section,
    borderRadius: 10,

    '&.hidden': {
      display: 'none'
    },

    '& > p': {
      fontSize: '.9rem',
      [theme.breakpoints.up('lg')]: {
        fontSize: '1rem'
      }
    },
    [theme.breakpoints.up('lg')]: {
      boxShadow: 'none'
    }
  },
  seccionHeaderContainer: {
    display: 'flex',
    [theme.breakpoints.up('lg')]: {
      width: 300
    }
  },
  title: {
    fontWeight: 600,
    fontSize: '1rem',
    flexGrow: 1,
    marginTop: theme.spacing(),
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main
  }
}))

export default useStyles
